import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import Api from '../../utils/API';
import ApiErrors from '../../utils/API/APIErrors';
import {
  errorsGlobalError,
  fetchColorPresetsFailed,
  fetchColorPresetsSuccess
} from '../../actions';

/** Every active palette, fetched once; each template's own are picked out of them locally. */
export const fetchColorPresetsSaga = function* (): SagaIterator {
  try {
    const response = yield call(Api.Design.getColorPresets);
    ApiErrors.checkOnApiError(response);

    yield put(fetchColorPresetsSuccess(response.result.presets || []));
  } catch (e) {
    // Surfaced rather than swallowed: with the palettes owned solely by the backend,
    // a failed fetch leaves the photographer with an empty colour section.
    yield put(fetchColorPresetsFailed());
    yield put(errorsGlobalError(e as ErrorEvent));
  }
};
